/************************************
MODULE: Store predictive search
WHAT IT DOES: Contains store search logic
*************************************/

(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    } else if (typeof exports === 'object') {
        module.exports = factory(require('jquery'));
    } else {
        root.returnExports = factory(root.jQuery);
    }
}(this, function ($) {

    function searchModule(el) {
        this.form = el;

        $.extend(this, this._defaults);
        this.settings = $.extend({}, this._settings, this.form.data());

        this.init();
    }

    function getHandlerUrl() {
        var url = '/old_app_code/safestore/handlers/PredictiveStoreSearch.ashx';

        if (window.appState.storeSearch) {
            return window.appState.storeSearch.handlerUrl || url;
        }

        return url;
    }

    function getNotAllowedUrl() {
        var url = '/storage-near-me/?frmsrch=1&notallowed=1';

        if (window.appState.storeSearch) {
            return window.appState.storeSearch.notAllowedUrl || url;
        }

        return url;
    }

    function getNearmeUrl() {
        var url = '/results/?type=Coords';

        if (window.appState.storeSearch) {
            return window.appState.storeSearch.nearmeUrl || url;
        }

        return url;
    }

    searchModule.prototype = {
        _defaults: {
            $input: null,
            $nearmebtn: null,
            $searchBtn: null,
            $locationType: null,
            $locationValue: null,
            $localizationRefineTitle : null,
            $typeahead: null,
            $refineSearch: null,
            scroll: null,
            lastRemoteQuery: "",
            searchResults: [],
            defaly: 200,
            timer: {}
        },
        _settings: {
            handlerUrl: getHandlerUrl(),
            refineSearchTemplate: "<span style='display: none' class='js-refine tt-suggestion tt-refine'>Type more to refine list further</span>",
            notAllowedUrl: getNotAllowedUrl(),
            nearmeUrl: getNearmeUrl()  //&lat= &lng=
        },
        init: function () {
            this.$input = this.form.find('input[id$="txtSearchTitle"]');
            if (!this.$input.length)
                return;

            if (this.$input.parents('.find-a-store_hidden').length) 
                return;

            this.$searchBtn = this.form.find('.js-store-search-btn');
            this.$locationType = this.form.find('input[id$="hdnlocationType"]');
            this.$locationValue = this.form.find('input[id$="hdnlocationValue"]');
            this.$nearmebtn = this.form.find('.js-find-a-store-near-me');

            this.$localizationLocations = this.$input.attr('data-locations-localization');
            this.$localizationStores = this.$input.attr('data-stores-localization');
            this.$localizationPostcode = this.$input.attr('data-postcode-localization');
            this.$localizationRefineTitle = this.$input.attr('data-refine-localization');

            if (typeof this.Handlebars == "undefined") {
                this.Handlebars = require('handlebars');
            }
            if (typeof this.TypeAhead == "undefined") {

                var that = this;
                require.ensure([], function () {
                    that.typeAhead = require('typeahead.bundle');
                    that.initTypeAhead();
                }, 'typeahead');
            }

            this.updateRefineTitle();
            this.initNearMe();
            
        },
        updateRefineTitle: function () {
            if (!this.$localizationRefineTitle) return;
            this.settings.refineSearchTemplate = 
                "<span style='display: none' class='js-refine tt-suggestion tt-refine'>" + this.$localizationRefineTitle + "</span>";
        },
        initNearMe: function () {
            this.$nearmebtn.on('click', this.nearMeOnClick.bind(this));
        },
        nearMeOnClick: function(e) {
            if (typeof e !== 'undefined' && typeof e.preventDefault === "function") {
                e.preventDefault();
            }
            navigator.geolocation.getCurrentPosition(this.getCurrentPosition.bind(this), this.getCurrentPositionError.bind(this));
        },
        getCurrentPosition: function(position) {
            if (typeof position.coords == 'undefined' || !this.settings.nearmeUrl) {
                this.getCurrentPositionError();
                return;
            }

            var query = "lat=" + encodeURIComponent(position.coords.latitude) + "&lng=" + encodeURIComponent(position.coords.longitude),
                finalUrl = this.settings.nearmeUrl + (this.settings.nearmeUrl.indexOf("?") >= 0 ? "&" : "?") + query;

            window.location.href = finalUrl;
        },
        getCurrentPositionError: function (error) {
            if (typeof error !== 'undefined' && typeof error.code !== 'undefined' && error.code == 1) {
                if (this.settings.notAllowedUrl) {
                    window.location.href = this.settings.notAllowedUrl;
                }
                return;
            }
            if (this.settings.nearmeUrl) {
                window.location.href = this.settings.nearmeUrl;
            }
        },
        initTypeAhead: function () {
               
            this.$typeahead = this.$input.typeahead({
                hint: true,
                highlight: true,
                minLength: 3
            },

                this.getDataSource("stores", "store", "<h3>" + this.$localizationStores + "</h3>", true),
                this.getDataSource("locations", "storelocation,Location", "<h3>" + this.$localizationLocations + "</h3>", true),
                this.getDataSource("postcodes", "postcode", "<h3>" + this.$localizationPostcode + "</h3>", true)
            );

            this.$refineSearch = $('.tt-menu-inner').append($(this.settings.refineSearchTemplate)).find('.js-refine');
            this.$typeahead.on("typeahead:select", { isRedirect: true }, this.updateInputs.bind(this));
            this.$typeahead.on("typeahead:autocomplete", this.updateInputs.bind(this));
            this.$typeahead.on("typeahead:cursorchange ", this.updateInputs.bind(this));

            this.form.on('beforesubmit', this.onSubmit.bind(this));

            this.$typeahead.on('typeahead:open', this.openTypehead.bind(this));
            this.$typeahead.on("typeahead:render", this.refreshScroll.bind(this));
            this.$typeahead.on("typeahead:autocomplete", this.refreshScroll.bind(this));

            if (!window.App.globals.isMobile && window.App.globals.getTop() == 0
                && this.$input.val().length > 3
                && this.$input.parents('.find-item').length == 0) {
                this.$input.blur();
                this.$input.focus();
            }
        },
        refreshScroll: function () {
            if (this.scroll != null) {
                this.scroll.refresh();
                this.onScroll();
            }
        },
        scrollRemove: function () {
            $('html').off('keydown', this.keyWatcher.bind(this));
            this.$input.off('keypress.storesearch');
            this.$input.off('keydown.storesearch');
            if (this.scroll != null) {
                this.scroll.destroy();
                this.scroll = null;
            }
        },
        keyWatcher: function (e) {
            if (this.scroll == null)
                return;

            var cursor = this.form.find('.tt-cursor');
            if (!cursor.length)
                return;

            var hei = cursor.outerHeight(),
                top = cursor[0].offsetTop - hei;

            switch (e.keyCode) {
                case 38:
                    e.stopPropagation();
                    e.preventDefault();
                    this.scroll.scrollTo(this.scroll.x, Math.max(Math.min(0, -top), this.scroll.maxScrollY), 0);
                    break;
                case 40:
                    e.stopPropagation();
                    e.preventDefault();
                    this.scroll.scrollTo(this.scroll.x, Math.max(this.scroll.maxScrollY, -top), 0);
                    break;
                case 33:
                case 34:
                    e.stopPropagation();
                    e.preventDefault();
                    break;
                default:
                    break;

            }
        },
        openTypehead: function (obj, datum, name) {
            if ($('html').hasClass('windows-mobile'))
                return;

            var ddmenu = this.form.find('.tt-menu');

            if (!window.App.globals.isMobile) {
                ddmenu.css('overflow', 'hidden');

                var that = this;
                require.ensure([], function () {
                    var iscroll = require('iscroll-probe');
                    that.scroll = new iscroll(ddmenu[0], {
                        probeType: 1,
                        scrollbars: 'custom',
                        interactiveScrollbars: true,
                        preventDefault: false,
                        preventDefaultOnlyTouch: true,
                        bounce: true,
                        deceleration: 0.001,
                        mouseWheel: true,
                        disableMouse: true,
                        scrollY: true,
                        click: false,
                        tap: true,
                        keyBindings: {
                            up: 38,
                            down: 40,
                            pageUp: 33,
                            pageDown: 34
                        }
                    });
    
                    that.scroll.on('scroll', that.onScroll.bind(that));
                    that.scroll.on('scrollend', that.onScroll.bind(that));
    
                    that.$input.on('keypress.storesearch', that.refreshScroll.bind(that));
                    that.$input.on('keydown.storesearch', that.refreshScroll.bind(that));
                    that.$input.on('blur.storesearch', that.scrollRemove.bind(that));
                }, 'iscroll-probe');
            }
            else {
                ddmenu.addClass('is-native-scroll');
            }


            $('html').on('keydown', this.keyWatcher.bind(this));


        },


        onScroll: function () {
            if (this.scroll == null)
                return;

            var pos = Math.abs(this.scroll.y),
                max = Math.abs(this.scroll.maxScrollY),
                min = 0;
            this.form[pos <= min ? 'addClass' : 'removeClass']('topped');
            this.form[pos >= max ? 'addClass' : 'removeClass']('bottomed');
        },

        updateInputs: function (e, suggestion) {
            var isRedirect = e.data && e.data.isRedirect;
            this.$locationValue.val(suggestion.Value);
            this.$locationType.val(suggestion.Type);

            if (isRedirect) {
                this.$searchBtn.trigger('click');
            }
        },

        onSubmit: function (e) {
            var value = this.$input.val().trim().toLowerCase();
            if (!this.$locationValue.val()) {

                for (var i = 0, l = this.searchResults.length; i < l; i++) {
                    var el = this.searchResults[i];

                    if (this.shouldReplace(el, value)) {
                        this.$locationType.val(el.Type);
                        this.$locationValue.val(el.Value);

                        this.$input.parent().find('.tt-hint').val(el.Title);
                        this.$input.val(el.Title);
                        break;
                    }
                }
                this.form.data('tracking-pageview-label', this.form.attr('data-tracking-pageview-label-base') + this.$input.val());
            } else {
                this.form.data('tracking-pageview-label', '/search_results?findastore=' + this.$input.val());
            }

            this.form.data('tracking-action', this.$input.val());

        },
        shouldReplace: function (searchRes, value) {
            if (stringStartsWith('manchester', value) && searchRes.Type === 'Store') {
                return false;
            }

            if (value.toLowerCase().length > 3 && stringStartsWith('bristol', value) && searchRes.Type === 'Store') {
                return false;
            }

            if (searchRes.Title.toLowerCase() == value) {
                return true;
            }

            if (this.searchResults.length === 1) {
                return true;
            } 

            return false;            

            function stringStartsWith(string, prefix) {
                return string.slice(0, prefix.length) == prefix;
            }
        },
        getDataSource: function (name, types, headerTemplate, isInHint) {
            var _this = this;
            return {
                name: name,
                displayKey: 'Title',
                templates: {
                    header: headerTemplate,
                    suggestion: _this.Handlebars.compile('<div><strong>{{Title}}</strong></div>')
                },
                limit: 20,
                isHint: isInHint,
                async: true,
                source: this.getSource.bind(this, name, types)
            }
        },
        getSource: function (name, types, query, proccess, asyncProccess) {
            var _this = this;

            if (this.timer[types]) {
                clearTimeout(_this.timer[types]);
            }

            this.timer[types] = setTimeout(function () {
                _this.updateRequest(query);

                _this.request.$ajaxRequest.done(function () {

                    //fltering result
                    var results = _this.filterResultsByTypes(_this.searchResults, types);

                    // show refine search message
                    if (name === 'postcodes') {
                        if (_this.searchResults.length >= 20) {
                            _this.$refineSearch.show();
                            _this.refreshScroll();
                        } else {
                            _this.$refineSearch.hide();
                            _this.refreshScroll();
                        }
                    }
                    asyncProccess(results);
                });

            }, this.delay);

            this.$locationType.val("");
            this.$locationValue.val("");
        },
        filterResultsByTypes: function (results, types) {
            var resultTypes = types.split(",");
            return $.grep(results, function (result) {
                var show = false;
                resultTypes.forEach(function (type) {
                    if (result.Type === type.trim()) {
                        show = true;
                    }
                });
                return show;
            });
        },
        request: {
            isRedundant: function (query) {
                var containsLastQuery = query.toLowerCase().indexOf(this.lastRemoteQuery.toLowerCase()) > -1;
                return !this.lastRequestHasResults && this.query && containsLastQuery;
            },
            lastRequestHasResults: false,
            lastRemoteQuery: ""
        },
        updateRequest: function (query) {
            var _this = this;

            if (this.request.query == query) { return; }

            if (!this.request.isRedundant(query)) {
                this.request.$ajaxRequest = $.Deferred();

                this.request.xhr && this.request.xhr.abort();

                this.request.xhr = $.ajax({
                    url: this.settings.handlerUrl,
                    type: "GET",
                    data: { term: query, searchInitiator : this.settings.searchInitiator },
                    dataType: "JSON",
                    async: true
                }).done(function (results) {
                    _this.searchResults = results;
                    _this.request.lastRemoteQuery = query;
                    _this.request.lastRequestHasResults = !!results.length;
                    _this.request.$ajaxRequest.resolve();
                });
            }
            this.request.query = query;
        },
    }

    return searchModule;

}));



/*****************
 ** WEBPACK FOOTER
 ** ./js/app/generic/generic.storesearch.js
 ** module id = 28
 ** module chunks = 24
 **/